import $axios from '@/api/apiPublic';

const getRatesVpsPaid = async () => {
  const response = await $axios.get('vps/rates');
  return response;
};

const getRatesMonitoring = async () => {
  const response = await $axios.get('monitoring/rates');
  return response;
};

export default {
  getRatesVpsPaid,
  getRatesMonitoring,
};
